module.exports = require("./src/ngAutocomplete.js");


/*****************
 ** WEBPACK FOOTER
 ** ngAutocomplete (bower component)
 ** module id = 160
 ** module chunks = 1
 **/